import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import CurrencyColumn from '../../../components/columns/currency-column';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const CarrierFeeColumn = ({ fulfillmentId }) => {
  const { labelFulfillment } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelCost } = labelFulfillment ?? {};

  if (!labelCost) {
    return '';
  }
  const { value, code } = labelCost;
  return <CurrencyColumn currencyCode={code} value={value} />;
};

CarrierFeeColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const CarrierFee = {
  getMessageDescriptor: () => messages.carrierFee,
  id: 'carrierFee',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <CarrierFeeColumn fulfillmentId={data.id} />;
  },
};
